
import { motion } from 'framer-motion';

export default function SimulatorHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b4343cffb6c8152f42553aa5d9a96c5f.jpg"
          alt="ラスベガス ビルボード投資 ストリップ夜景 デジタル広告ディスプレイ"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block px-4 py-1.5 bg-amber-500/20 border border-amber-500/30 rounded-full text-amber-400 text-sm font-medium mb-6">
              INVESTMENT CALCULATOR
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
              ラスベガス &nbsp; &nbsp; &nbsp; &nbsp; ビルボード投資
              <br />
              シミュレーター
            </h1>
            <h2 className="text-2xl text-gray-300 font-semibold mb-4">
              デジタルビルボード・屋外広告投資の収益性を
              <br />
              リアルタイムで可視化
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-lg">
              ラスベガス主要エリアにおけるビルボード投資の想定広告収益、ROI、回収期間を即時計算。
              <br />
              税務メリットや資産価値も含めた投資判断をサポートします。
            </p>
            <a
              href="#simulator"
              className="inline-flex items-center gap-3 px-8 py-4 bg-amber-500 text-black font-semibold rounded-full hover:bg-amber-400 transition-all cursor-pointer group whitespace-nowrap"
            >
              シミュレーションを開始
              <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-down-line text-white"></i>
              </div>
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hidden lg:block"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                  <div className="text-5xl font-bold text-white mb-2">24%</div>
                  <div className="text-gray-400 text-sm">平均年間ROI</div>
                  <div className="text-amber-400 text-xs mt-1">過去3年間実績</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                  <div className="text-5xl font-bold text-white mb-2">3.2<span className="text-2xl">年</span></div>
                  <div className="text-gray-400 text-sm">平均投資回収期間</div>
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                  <div className="text-5xl font-bold text-white mb-2">127</div>
                  <div className="text-gray-400 text-sm">運用中ビルボード</div>
                </div>
                <div className="bg-amber-500/20 backdrop-blur-sm rounded-2xl p-6 border border-amber-500/30">
                  <div className="text-5xl font-bold text-amber-400 mb-2">98%</div>
                  <div className="text-gray-300 text-sm">稼働率</div>
                  <div className="text-amber-400 text-xs mt-1">業界最高水準</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
